module.exports = require("@azure/opentelemetry-instrumentation-azure-sdk");